import { render } from "./HeroApprovalTravelModal.vue?vue&type=template&id=a89f788a&scoped=true"
import script from "./HeroApprovalTravelModal.vue?vue&type=script&lang=js"
export * from "./HeroApprovalTravelModal.vue?vue&type=script&lang=js"

import "./HeroApprovalTravelModal.vue?vue&type=style&index=0&id=a89f788a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89f788a"]])

export default __exports__